<template>
  <MoreOptionsMenuButton
    v-if="
      currentUser?.hasPermission('cctv_reports.change_cctvreport') ||
      currentUser?.hasPermission('cctv_reports.delete_cctvreport') ||
      canDownloadReport
    "
  >
    <template #button="props">
      <v-btn
        v-bind="props"
        :loading="loading"
        :disabled="disabled"
        class="text-capitalize"
        append-icon="mdi-menu-down"
        variant="outlined"
      >
        More Options
      </v-btn>
    </template>
    <v-list-item
      v-if="canDownloadReport"
      title="Download Report"
      @click="emit('download-report-pressed')"
    >
    </v-list-item>
    <v-list-item
      v-if="currentUser!.hasPermission('cctv_reports.change_cctvreport')"
      title="Edit Report"
      @click="emit('edit-report-pressed')"
    >
    </v-list-item>
    <v-list-item
      v-if="currentUser!.hasPermission('cctv_reports.delete_cctvreport')"
      title="Delete Report"
      @click="emit('delete-report-pressed')"
    >
    </v-list-item>
  </MoreOptionsMenuButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { ReportStateEnum } from '@/models/report'
import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'

interface Props {
  reportState: ReportStateEnum
  loading?: boolean
  disabled?: boolean
}
const props = defineProps<Props>()

interface Emit {
  (e: 'download-report-pressed'): void
  (e: 'edit-report-pressed'): void
  (e: 'delete-report-pressed'): void
}
const emit = defineEmits<Emit>()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)

const canDownloadReport = computed(
  () =>
    props.reportState == ReportStateEnum.Submitted &&
    currentUser.value?.hasPermission('cctv_reports.download_cctvreport')
)
</script>
